import cn from 'classnames'

import { useSafetyTranslation } from 'cng-common/features/translations'
import { Tooltip } from 'core-components/library/tooltip'

import { FINANCIAL_COCKPIT_TRANSLATION_KEYS } from '../../../../configs/translations'

import styles from './CockpitSidebarToggle.module.scss'

const KEYS = FINANCIAL_COCKPIT_TRANSLATION_KEYS.scopePanel

export interface ICockpitSidebarToggle {
  isOpen: boolean
  /** The id of the column the button shows and hides. */
  controls: string
  onToggle: () => void
  /** `key`: a white square key on the grey tray. `chip`: the framed icon chip of a white panel's
   *  row (`CockpitIconButton`), as at the head of the plan deck. */
  appearance?: 'key' | 'chip'
}

/** Shows and hides the page's filter column, from the same spot in both states: the first control
 *  of the row it leads. The mark is the desktop "side panel" toggle, its left pane
 *  filled while the column is open. */
export const CockpitSidebarToggle = ({
  isOpen,
  controls,
  onToggle,
  appearance = 'key',
}: ICockpitSidebarToggle) => {
  const t = useSafetyTranslation()
  const label = t(isOpen ? KEYS.hideSidebar : KEYS.showSidebar)

  return (
    <div className={cn(styles.root, styles[appearance])}>
      <Tooltip inline tipContent={() => <span>{label}</span>}>
        <button
          type="button"
          className={cn(styles.button, { [styles.open]: isOpen })}
          aria-label={label}
          aria-expanded={isOpen}
          aria-controls={controls}
          onClick={onToggle}
        >
          <svg className={styles.icon} viewBox="0 0 24 24" aria-hidden="true">
            {isOpen && (
              <path className={styles.pane} d="M5.5 4.5h4v15h-4a2 2 0 0 1-2-2v-11a2 2 0 0 1 2-2Z" />
            )}
            <rect x="3.5" y="4.5" width="17" height="15" rx="2" />
            <path d="M9.5 4.5v15" />
          </svg>
        </button>
      </Tooltip>
    </div>
  )
}

CockpitSidebarToggle.displayName = 'CockpitSidebarToggle'
